// Guest support has a separate HttpOnly capability and CSRF token. Authenticated
// visitors also keep the application's existing session/CSRF protections.
let pendingContext;
const API = process.env.REACT_APP_BACKEND_URL;
export const supportContext = () => {
  if (!pendingContext) pendingContext = window.fetch(`${API}/api/support-chat/visitor/context`, { credentials: 'include', cache: 'no-store' })
    .then(async response => { if (!response.ok) throw new Error('Support is unavailable. Please try again.'); return response.json(); })
    .finally(() => { pendingContext = null; });
  return pendingContext;
};
export async function supportFetch(input, init = {}) {
  const isWrite = !['GET', 'HEAD', 'OPTIONS'].includes((init.method || 'GET').toUpperCase());
  const headers = new Headers(init.headers);
  if (isWrite) headers.set('X-Support-CSRF', (await supportContext()).csrf_token);
  return window.fetch(input, { cache: 'no-store', ...init, headers, credentials: 'include' });
}